import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RightSidebarState {
  activeTab: string;
  filterTime: string;
  view: "all" | "follows";
  syncWithSidebar: boolean;
}

const initialState: RightSidebarState = {
  activeTab: "STOCK",
  filterTime: "24 hrs",
  view: "all",
  syncWithSidebar: false,
};

const allowedSyncTimes = ["24 hrs", "7 days", "30 days"];

export const rightSidebarSlice = createSlice({
  name: "rightSidebar",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },
    setFilterTime: (state, action: PayloadAction<string>) => {
      const newTime = action.payload;
      if (state.syncWithSidebar && !allowedSyncTimes.includes(newTime)) {
        state.syncWithSidebar = false;
        return;
      }
      state.filterTime = newTime;
    },

    setView: (state, action: PayloadAction<"all" | "follows">) => {
      state.view = action.payload;
    },
    setSyncWithSidebar: (state, action: PayloadAction<boolean>) => {
      state.syncWithSidebar = action.payload;
    },
  },
});

export const { setActiveTab, setFilterTime, setView, setSyncWithSidebar } =
  rightSidebarSlice.actions;
export default rightSidebarSlice.reducer;
